// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deleted_users_header_box{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0px;
  height: 50px;
  background-color: var(--bg-card);
  border-bottom: 1px solid var(--border);
  margin-bottom: 30px;
}

.deleted_users_count_div{
  display: flex;
  align-items: center;
  background-color: var(--bg);
  color: var(--primary);
  padding: 3px 10px;
  border-radius: 5px;
}

.deleted_users_open_note {
  cursor: pointer;
}

.deleted_users_modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(80, 67, 74, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
}

.deleted_users_modal_container {
  background: var(--bg-card);
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  position: relative;
  width: 1000px;
  height: 35%
}

.deleted_users_modal_close_button_div {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

.deleted_users_modal_details {
  height: 85%;
}

.deleted_users_modal_overlay.open {
  opacity: 1;
  visibility: visible;
}

.deleted_users_modal_button_div {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.deleted_users_modal_button_div .close{
  padding: 7px 20px;
  border-radius: 4px;
  background-color: var(--bg-card);
  border: solid 1px black;
}

.deleted_users_modal_button_div .save{
  padding: 7px 20px;
  border-radius: 4px;
  background-color: var(--primary);
  color: white;
  border: solid 1px white;
}

.deleted_users_modal_title{
  margin: 0 0 20px 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/users/deletedUsers/deletedUsers.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,gCAAgC;EAChC,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,iEAAiE;AACnE;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".deleted_users_header_box{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 0px;\n  height: 50px;\n  background-color: var(--bg-card);\n  border-bottom: 1px solid var(--border);\n  margin-bottom: 30px;\n}\n\n.deleted_users_count_div{\n  display: flex;\n  align-items: center;\n  background-color: var(--bg);\n  color: var(--primary);\n  padding: 3px 10px;\n  border-radius: 5px;\n}\n\n.deleted_users_open_note {\n  cursor: pointer;\n}\n\n.deleted_users_modal_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(80, 67, 74, 0.3);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;\n}\n\n.deleted_users_modal_container {\n  background: var(--bg-card);\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\n  position: relative;\n  width: 1000px;\n  height: 35%\n}\n\n.deleted_users_modal_close_button_div {\n  display: flex;\n  flex-direction: row;\n  justify-content: end;\n}\n\n.deleted_users_modal_details {\n  height: 85%;\n}\n\n.deleted_users_modal_overlay.open {\n  opacity: 1;\n  visibility: visible;\n}\n\n.deleted_users_modal_button_div {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.deleted_users_modal_button_div .close{\n  padding: 7px 20px;\n  border-radius: 4px;\n  background-color: var(--bg-card);\n  border: solid 1px black;\n}\n\n.deleted_users_modal_button_div .save{\n  padding: 7px 20px;\n  border-radius: 4px;\n  background-color: var(--primary);\n  color: white;\n  border: solid 1px white;\n}\n\n.deleted_users_modal_title{\n  margin: 0 0 20px 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
